const SOURCE = "atomicpay-sales-builder";

function blockRect(anchor) {
  const child = anchor?.firstElementChild;
  const rect = (child || anchor)?.getBoundingClientRect?.();
  if (rect && (rect.width || rect.height)) return rect;
  return anchor.getBoundingClientRect();
}

function insertionIndex(blocks, y) {
  for (let index = 0; index < blocks.length; index += 1) {
    const rect = blockRect(blocks[index]);
    if (y < rect.top + rect.height / 2) return index;
  }
  return blocks.length;
}

function ensureInsertLine() {
  let line = document.getElementById("sales-builder-insert");
  if (line) return line;
  line = document.createElement("div");
  line.id = "sales-builder-insert";
  line.className = "sales-builder-insert";
  line.hidden = true;
  document.body.appendChild(line);
  return line;
}

function hideInsertLine() {
  const line = document.getElementById("sales-builder-insert");
  if (line) line.hidden = true;
}

function showInsertLine(container, blocks, index) {
  const line = ensureInsertLine();
  const host = container.getBoundingClientRect();
  let top = host.top + Math.min(host.height, 24) / 2;
  if (blocks.length && index <= 0) top = blockRect(blocks[0]).top;
  else if (blocks.length && index >= blocks.length) top = blockRect(blocks[blocks.length - 1]).bottom;
  else if (blocks.length) top = (blockRect(blocks[index - 1]).bottom + blockRect(blocks[index]).top) / 2;
  line.hidden = false;
  line.style.top = `${top}px`;
  line.style.left = `${host.left}px`;
  line.style.width = `${Math.max(host.width, 24)}px`;
}

function nearestSection(x, y) {
  const sections = [...document.querySelectorAll("[data-section-id]")];
  if (!sections.length) return null;
  let best = sections[0];
  let bestDistance = Infinity;
  for (const section of sections) {
    const rect = section.getBoundingClientRect();
    const inside = y >= rect.top && y <= rect.bottom;
    if (inside) return section;
    const distance = y < rect.top ? rect.top - y : y - rect.bottom;
    if (distance < bestDistance) {
      bestDistance = distance;
      best = section;
    }
  }
  return best;
}

export function describeSalesDrop(x, y, ignoreId = "") {
  document.querySelectorAll(".is-builder-drop").forEach((node) => node.classList.remove("is-builder-drop"));
  const page = document.querySelector(".sales-page");
  const pageRect = page?.getBoundingClientRect();
  const overPage = pageRect && x >= pageRect.left && x <= pageRect.right && y >= pageRect.top && y <= pageRect.bottom;
  if (!(x >= 0) || !(y >= 0) || !overPage) {
    hideInsertLine();
    return null;
  }
  const point = document.elementFromPoint(x, y);
  const section = point?.closest?.("[data-section-id]") || nearestSection(x, y);
  if (!section) {
    hideInsertLine();
    return null;
  }
  const column = point?.closest?.("[data-column-index]");
  const container = column || section;
  const blocks = [...container.querySelectorAll(":scope > .sales-preview-anchor")].filter(
    (node) => node.getAttribute("data-block-id") !== ignoreId
  );
  const index = insertionIndex(blocks, y);
  if (!blocks.length) container.classList.add("is-builder-drop");
  showInsertLine(container, blocks, index);
  const rowId = column?.getAttribute("data-row-id") || "";
  const columnRaw = column?.getAttribute("data-column-index");
  return {
    sectionId: section.getAttribute("data-section-id") || "",
    rowId,
    columnIndex: columnRaw == null || columnRaw === "" ? null : Number(columnRaw),
    index,
  };
}

export function postSalesDrop(target, origin) {
  window.parent?.postMessage(
    {
      source: SOURCE,
      type: "drop-target",
      sectionId: target?.sectionId || "",
      rowId: target?.rowId || "",
      columnIndex: target ? target.columnIndex : null,
      index: target ? target.index : null,
    },
    origin || "*"
  );
}

export function bindSalesBuilderFrame(originRef) {
  let drag = null;

  const clearDrag = () => {
    drag?.anchor?.classList.remove("is-builder-source");
    document.body.classList.remove("is-builder-moving");
    hideInsertLine();
    drag = null;
  };

  const onDown = (event) => {
    if (event.button !== 0) return;
    if (event.target.closest?.("input, textarea, select, summary")) return;
    const anchor = event.target.closest?.(".sales-preview-anchor");
    const elementId = anchor?.getAttribute("data-block-id");
    if (!anchor || !elementId) return;
    drag = {
      id: elementId,
      anchor,
      x: event.clientX,
      y: event.clientY,
      pointerId: event.pointerId,
      active: false,
      target: null,
    };
  };

  const onMove = (event) => {
    if (!drag || event.pointerId !== drag.pointerId) return;
    const distance = Math.hypot(event.clientX - drag.x, event.clientY - drag.y);
    if (!drag.active) {
      if (distance < 6) return;
      drag.active = true;
      drag.anchor.classList.add("is-builder-source");
      document.body.classList.add("is-builder-moving");
    }
    event.preventDefault();
    drag.target = describeSalesDrop(event.clientX, event.clientY, drag.id);
  };

  const onUp = (event) => {
    if (!drag || event.pointerId !== drag.pointerId) return;
    const current = drag;
    clearDrag();
    document.querySelectorAll(".is-builder-drop").forEach((node) => node.classList.remove("is-builder-drop"));
    if (!current.active || !current.target?.sectionId) return;
    window.parent?.postMessage(
      {
        source: SOURCE,
        type: "move-element",
        elementId: current.id,
        sectionId: current.target.sectionId,
        rowId: current.target.rowId || "",
        columnIndex: current.target.columnIndex,
        index: current.target.index,
      },
      originRef.current || "*"
    );
  };

  const onClick = (event) => {
    const block = event.target.closest?.("[data-block-id]");
    const section = event.target.closest?.("[data-section-id]");
    if (event.target.closest?.("a, button, input, textarea, select, summary")) event.preventDefault();
    const id = block?.getAttribute("data-block-id") || section?.getAttribute("data-section-id");
    if (!id) return;
    window.parent?.postMessage(
      {
        source: SOURCE,
        type: "select",
        id,
        kind: block ? "element" : "section",
      },
      originRef.current || "*"
    );
  };

  const onContextMenu = (event) => {
    event.preventDefault();
    const block = event.target.closest?.("[data-block-id]");
    const section = event.target.closest?.("[data-section-id]");
    const id = block?.getAttribute("data-block-id") || section?.getAttribute("data-section-id");
    if (!id) return;
    window.parent?.postMessage(
      {
        source: SOURCE,
        type: "menu",
        id,
        kind: block ? "element" : "section",
        x: event.clientX,
        y: event.clientY,
      },
      originRef.current || "*"
    );
  };

  const onKeyDown = (event) => {
    const field = event.target;
    if (field instanceof HTMLElement && field.closest("input, textarea, select, [contenteditable='true']")) return;
    const command = event.metaKey || event.ctrlKey;
    if (command && event.key.toLowerCase() === "d") {
      event.preventDefault();
      window.parent?.postMessage({ source: SOURCE, type: "duplicate" }, originRef.current || "*");
    } else if (event.key === "Delete" || event.key === "Backspace") {
      event.preventDefault();
      window.parent?.postMessage({ source: SOURCE, type: "delete" }, originRef.current || "*");
    }
  };

  const blockNativeDrag = (event) => event.preventDefault();
  document.addEventListener("pointerdown", onDown, true);
  document.addEventListener("pointermove", onMove);
  document.addEventListener("pointerup", onUp);
  document.addEventListener("pointercancel", onUp);
  document.addEventListener("click", onClick, true);
  document.addEventListener("contextmenu", onContextMenu);
  document.addEventListener("keydown", onKeyDown);
  document.addEventListener("dragstart", blockNativeDrag, true);

  return () => {
    clearDrag();
    hideInsertLine();
    document.removeEventListener("pointerdown", onDown, true);
    document.removeEventListener("pointermove", onMove);
    document.removeEventListener("pointerup", onUp);
    document.removeEventListener("pointercancel", onUp);
    document.removeEventListener("click", onClick, true);
    document.removeEventListener("contextmenu", onContextMenu);
    document.removeEventListener("keydown", onKeyDown);
    document.removeEventListener("dragstart", blockNativeDrag, true);
  };
}

export function syncSalesSelection(selectedId) {
  document.querySelectorAll(".is-builder-selected").forEach((node) => node.classList.remove("is-builder-selected"));
  if (!selectedId) {
    window.parent?.postMessage({ source: SOURCE, type: "box", id: "" }, "*");
    return;
  }
  const anchor = document.querySelector(
    `[data-block-id="${CSS.escape(selectedId)}"], [data-section-id="${CSS.escape(selectedId)}"]`
  );
  const target = anchor?.classList.contains("sales-preview-anchor") ? anchor.firstElementChild : anchor;
  target?.classList.add("is-builder-selected");
  if (!target) {
    window.parent?.postMessage({ source: SOURCE, type: "box", id: "" }, "*");
    return;
  }
  const rect = target.getBoundingClientRect();
  window.parent?.postMessage(
    {
      source: SOURCE,
      type: "box",
      id: selectedId,
      kind: anchor?.hasAttribute("data-block-id") ? "element" : "section",
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height,
    },
    "*"
  );
}
